const admarktTabs = [
  { id: 'tab-1', disabled: false, isActive: true, name: 'company' },
  { id: 'tab-2', disabled: true, isActive: false, name: 'contact' },
  { id: 'tab-3', disabled: true, isActive: false, name: 'invoice' },
  { id: 'tab-4', disabled: true, isActive: false, name: 'link_account' },
];

export default admarktTabs;
